export default __webpack_public_path__ + "static/media/shoes.83ad590a.svg";